export default __webpack_public_path__ + "static/media/bücherwurm.702e8577.jpg";